export default "__VITE_ASSET__CODzihYX__"